import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

/**
 * LegalDocumentView — renderiza um documento legal (Markdown) com tipografia de
 * documento/contrato: hierárquica, espaçosa, legível. Diferente do
 * MarkdownRenderer interno (tema escuro + callouts de tutorial), este é pensado
 * para o usuário final ler termos/privacidade/cookies. Adapta a light/dark.
 *
 * @param {{ content: string, className?: string }} props
 */
export default function LegalDocumentView({ content, className }) {
    if (!content) return null;

    return (
        <div
            className={cn(
                'prose prose-slate dark:prose-invert max-w-none',
                'leading-relaxed',
                // Headings
                'prose-headings:font-semibold prose-headings:text-foreground-strong',
                'prose-h1:text-2xl prose-h1:mt-8 prose-h1:mb-4 prose-h1:tracking-tight',
                'prose-h2:text-xl prose-h2:mt-7 prose-h2:mb-3',
                'prose-h3:text-lg prose-h3:mt-5 prose-h3:mb-2',
                // Text
                'prose-p:text-foreground-secondary prose-p:my-3',
                'prose-li:text-foreground-secondary prose-li:my-1',
                'prose-strong:text-foreground-strong prose-strong:font-semibold',
                // Links
                'prose-a:text-blue-600 dark:prose-a:text-blue-400 prose-a:no-underline hover:prose-a:underline',
                // Structure
                'prose-hr:border-border prose-hr:my-8',
                'prose-blockquote:border-l-4 prose-blockquote:border-border prose-blockquote:text-foreground-muted prose-blockquote:not-italic prose-blockquote:pl-4',
                // Tables
                'prose-table:text-sm',
                'prose-th:text-foreground-strong prose-th:border-border prose-th:px-3 prose-th:py-2',
                'prose-td:border-border prose-td:px-3 prose-td:py-2',
                className,
            )}
        >
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    a: ({ href, children }) => (
                        <a href={href} target="_blank" rel="noopener noreferrer">
                            {children}
                        </a>
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
}
